// apiConfig.js

const BASE_URL = 'https://api.kis-v.com'; // Replace with your actual API base URL

export default BASE_URL;
